import { render, staticRenderFns } from "./SmallScaleDisplayer.vue?vue&type=template&id=7928cc6f&scoped=true"
import script from "./SmallScaleDisplayer.vue?vue&type=script&lang=ts"
export * from "./SmallScaleDisplayer.vue?vue&type=script&lang=ts"
import style0 from "./SmallScaleDisplayer.vue?vue&type=style&index=0&id=7928cc6f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7928cc6f",
  null
  
)

export default component.exports